exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".asset-configuration {\n    background-color: white;\n    height: 100vh;\n}\n", ""]);

// exports
